import {
  Cards,
  WishesCards,
  WishesCardsUserInfo,
} from "../../components/cards/Cards";
import "./Dashboard.css";
import Avatar from "@mui/material/Avatar";
import {
  BarChart,
  BarSeries,
  BarElement,
  Axis,
  ChartsTooltip,
  ChartsLegend,
} from "@mui/x-charts";
import { Box, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import CustomPagination from "../../components/CustomPagination";
import { CardContainer, ProfileCard } from "../../components/AnniversaryCard";
import { CiUser } from "react-icons/ci";
import { FiPlus } from "react-icons/fi";
// Component --------------------------------------------
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import WidgetsButton from "../../components/Widgets/button";
import Widgets from "../../components/Widgets";
import WidgetsIcon from "../../components/Widgets/icon";

import { RxCross2 } from "react-icons/rx";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import Button from "react-bootstrap/Button";

import { AgGridReact } from "ag-grid-react";

import { Link, useNavigate } from "react-router-dom";
import { Badge, Card, Col, Container, Form, Row } from "react-bootstrap";
import AttendanceChart from "../../components/Charts/AttendanceChart";
import RoleChart from "../../components/Charts/RoleCharts";
import CircularProgress from "../../components/CircularProgress";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useSelector, useDispatch } from "react-redux";

import {
  commonGetData,
  commonGetDataOne,
  commonGetDataTwo,
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
} from "../../redux/slices/commonSlice";

import {
  getChartData,
  initChartStatus,
} from "../../redux/slices/dashboardSlice";

import {
  getDashboardDatas,
  getEmployeeStaffListPath,
  getNotificationsPath,
  notifyApproveRequestPath,
  saveEmployeeWishMessagePath,
} from "../../services/config";

import { useGridStatePersistence } from "@mui/x-data-grid/internals";
import {
  getCurrentDate,
  getInitials,
  getInitialColor,
  getCapitalizeWord,
} from "../../services/commonServices";

import { HasPermission } from "../../services/hasPermission";
import { HasHeaderPermission } from "../../services/hasHeaderPermission";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const dashboardState = useSelector((state) => state.dashboard);

  const [isAlert, setAlert] = useState(false);
  const [isBranchAlert, setBranchAlert] = useState(false);
  const [isDepartmentAlert, setDepartmentAlert] = useState(false);
  const [isEmployerIdAlert, setEmployerIdAlert] = useState(false);
  const [isShiftAlert, setShiftAlert] = useState(false);
  const [dashboard, setDashboard] = useState({});
  const [selectedLeave, setSelectedLeave] = useState({});

  const [approveStatus, setApproveStatus] = useState({
    notifyId: "",
    staffId: "",
    approve: "",
    reason: "",
  });

  const [description, setDescription] = useState([]);
  const [filterDescription, setFilterDescription] = useState([]);

  const [designationSummary, setDesignationSummary] = useState([]);
  const [monthlySummary, setMonthlySummary] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [whishType, setWhishType] = useState("");
  const [userData, setUserData] = useState({});
  const [wishState, setWishState] = useState({
    staffId: "",
    wishes: "",
  });

  const getUserRecordPath = `/admin/checkUserRecords?userId=${user.user_id}`;
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const getNotification = useCallback(() => {
    const path = `${getNotificationsPath}${user.user_id}`;
    dispatch(commonGetDataTwo(path));
  }, []);

  useEffect(() => {
    getNotification();
  }, []);

  const getUserRecord = useCallback(() => {
    const data = {
      path: getDashboardDatas,
      data: {
        userId: user.user_id,
      },
    };
    dispatch(commonSaveData(data));
    dispatch(commonGetData(getUserRecordPath));
    dispatch(
      getChartData({
        userId: user.user_id,
        selectedDate: getCurrentDate(),
      })
    );
  });

  useEffect(() => {
    getUserRecord();
  }, []);

  useEffect(() => {
    if (commonState.commonGetSuccess) {
      for (let key in commonState.commonGetData) {
        if (commonState.commonGetData.hasOwnProperty(key)) {
          if (
            key == "isBranchRecord" &&
            commonState.commonGetData[key] === false
          ) {
            setBranchAlert(true);
            setAlert(true);
            break;
          } else if (
            key == "isDepartmentRecord" &&
            commonState.commonGetData[key] === false
          ) {
            setDepartmentAlert(true);
            setAlert(true);
            break;
          } else if (
            key == "isEmployerId" &&
            commonState.commonGetData[key] === false
          ) {
            setEmployerIdAlert(true);
            setAlert(true);
            break;
          } else if (
            key == "isShift" &&
            commonState.commonGetData[key] === false
          ) {
            setShiftAlert(true);
            setAlert(true);
            break;
          }
        }
      }
      dispatch(initCommonState());
    }

    if (commonState.commonGetTwoSuccess) {
      const array = commonState.commonGetTwoData?.leaveRequests?.filter(
        (item) => {
          return item.referenceId == "1" && item.approved == "0";
        }
      ) || [];
      setDescription(array);
      setFilterDescription(array);
    }

    if (commonState.commonGetError) {
      dispatch(initCommonState());
    }

    if (commonState.commonSuccess) {
      setDashboard(commonState.commonData);
      dispatch(initCommonState());
    }

    if (commonState.commonSuccessOne) {
      toast.success(commonState.commonMessageOne);
      setApproveStatus((pre) => ({
        ...pre,
        reason: "",
      }));
      setWishState((pre) => ({
        ...pre,
        staffId: "",
        wishes: "",
      }));
      handleClose();
      handleClose1();
      dispatch(initCommonState());
      getNotification();
    }

    if (commonState.commonGetOneSuccess) {
      if (
        commonState.commonGetOneData == undefined ||
        commonState.commonGetOneData == ""
      ) {
        setUsersList([]);
        dispatch(initCommonState());
      } else {
        setUsersList(commonState.commonGetOneData);
        dispatch(initCommonState());
      }
    }
    if (dashboardState.chartSuccess) {
      setDesignationSummary(dashboardState.chartData?.designationSummary || []);
      setMonthlySummary(dashboardState.chartData?.monthlySummary || []);
    }
    if (dashboardState.chartError) {
      toast.error(dashboardState.chartMessage);
      dispatch(initChartStatus());
    }
  }, [commonState, dashboardState, dispatch]);

  const path = `${getEmployeeStaffListPath}${user.user_id}`;

  const [usersList, setUsersList] = useState([]);

  const getEmployeeList = useCallback(() => {
    dispatch(commonGetDataOne(path));
  }, []);

  useEffect(() => {
    getEmployeeList();
  }, []);

  const [leaveActionType, setLeaveActionType] = useState("");

  const submitNotification = async (id, staffData, status, type) => {
    
    setSelectedLeave(staffData);
    setLeaveActionType(type);
    setApproveStatus({
      ...approveStatus,
      notifyId: id,
      staffId: staffData.staff_id,
      approve: status,
    });
    handleShow();
  };

  const handleReason = (e) => {
    const {
      target: { name, value },
    } = e;
    setApproveStatus({
      ...approveStatus,
      [name]: value,
    });
  };

  const saveApprovalStatus = () => {
    const data = {
      path: notifyApproveRequestPath,
      data: {
        notifyId: approveStatus.notifyId,
        staffId: approveStatus.staffId,
        approve: approveStatus.approve,
        reason: approveStatus.reason,
      },
    };
    dispatch(commonSaveDataOne(data));
  };

  const columns = [
    {
      headerName: "Employee ID",
      field: "empId",
      pinned: true,
      width: "120px",
    },
    {
      headerName: "Employee Name",
      field: "staffName",
      pinned: true,
       width: "260px",
    },
    {
      headerName: "Leave Type",
      field: "leave_name",
    },
    {
      headerName: "From Date",
      field: "start_date",
      width: "120px",
    },
    {
      headerName: "To Date",
      field: "end_date",
      width: "120px",
    },
    {
      headerName: "Total days",
      field: "duration",
      width: "100px",
    },
    {
      headerName: "Reason",
      field: "reason",
      autoHeight: true,
      cellClass: "wrap-text-cell",
      width: "280px"
    },
    {
      headerName: "Action",
      cellRenderer: (rowData) => {
        return HasPermission("Leave Requests Summary", "edit") ? (
          <div
            className="d-flex align-items-center justify-content-start gap-2"
            style={{ position: "relative", top: "4px" }}
          >
            <button
              className="universal-btn"
              onClick={() =>
                submitNotification(
                  rowData.data.id,
                  rowData.data,
                  1,
                  "Approve Request"
                )
              }
              style={{ width: "100px", height: "30px", lineHeight: "10px" }}
            >
              Approve
            </button>

            <button
              onClick={() =>
                submitNotification(
                  rowData.data.id,
                  rowData.data,
                  2,
                  "Reject Request"
                )
              }
              className="secondary-btn"

              style={{
                width: "100px", 
                height: "30px",
                lineHeight: "10px",
                fontSize: "13px"
              }}
            >
              Reject
            </button>
          </div>
        ) : null;
      },
      pinned: "right"
    },
  ];

  const [searchQuery, setSearchQuery] = useState("");
  const searchDetails = ({ target: { name, value } }) => {
    setSearchQuery(value);

    const filteredData = filterDescription?.filter((item) => {
      // return item.staffName.toLowerCase() === value.toLowerCase();
      return (
        item.staffName.toLowerCase().includes(value.toLowerCase()) ||
        item.empId.toLowerCase().includes(value.toLowerCase())
      );
    }) || [];
    setDescription(filteredData);
  };

  const handleWhishes = (type, user) => {
    setWhishType(type);
    setUserData(user);
    setWishState((preState) => ({
      ...preState,
      staffId: user.staffId,
    }));
    userData.employeeId;
    handleShow1();
  };

  const handleWishInputChange = ({ target: { name, value } }) => {
    setWishState((preState) => ({
      ...preState,
      [name]: value,
    }));
  };

  const submitWhishes = (event) => {
    event.preventDefault();

    const data = {
      path: saveEmployeeWishMessagePath,
      data: { staffId: wishState.staffId, wishMessage: wishState.wishes },
    };
    dispatch(commonSaveDataOne(data));
  };

  const theme = localStorage.getItem("theme")

  // Current component-------------------------------
  return HasHeaderPermission("Dashboard", "view") ? (
    <div className="Dashboard">
      <div className="Dashboard-head">
        <div className="Dashboard-card">
          {isAlert && (
            <div className="setting-notification">
              <div className="record-div">
                <div>
                  Records in your settings are not configured. To start, click
                  the link to complete.
                </div>

                {isBranchAlert && (
                  <Link to="/company_branches">Add Branch</Link>
                )}
                {isDepartmentAlert && (
                  <Link to="/company-departments">Add Department</Link>
                )}
                {isEmployerIdAlert && (
                  <Link to="/my-employee-id">Add Employer Id</Link>
                )}
                {isShiftAlert && (
                  <Link to="/attendance-settings-shifts">Add Shift</Link>
                )}
              </div>
            </div>
          )}
          <div className="Dashboard-card-items" style={{ padding: "20px" }}>
            <Cards
              className={"tot"}
              title={"Total Employees"}
              count={dashboard.totalStaff}
              supCount={dashboard.totalStaff}
            />
            <Cards
              className={"act"}
              title={"Active Employees"}
              count={dashboard.activeStaff}
              supCount={dashboard.totalStaff}
            />
            <Cards
              className={"pres"}
              title={"Present Employees"}
              count={dashboard.presentCount}
              supCount={dashboard.activeStaff}
            />
            <Cards
              className={"abs"}
              title={"Absent Employees"}
              count={dashboard.absentCount}
              supCount={dashboard.activeStaff}
            />
            <Cards
              className={"warn"}
              title={"New Joinee"}
              count={dashboard.newJoinees}
              supCount={dashboard.activeStaff}
            />
          </div>
        </div>
      </div>
      {/* CHART SECTION */}
      <div style={{ position: "relative", top: isAlert ? "30px" : "" }}>
        <Row className="px-5">
          <Col sm="8">
            <Widgets
              body={
                monthlySummary.length && (
                  <AttendanceChart attendanceData={monthlySummary} />
                )
              }
            />
          </Col>
          <Col sm="4">
            <Widgets
              body={
                designationSummary.length && (
                  <RoleChart pieData={designationSummary} />
                )
              }
            />
          </Col>
        </Row>
      </div>
      {/* WISHES */}
      <div className="Dashboard-wishes-container">
        <Row>
          {dashboard?.workAnniversaryList?.length > 0 ? (
            <Col sm="4" className="mb-3">
              <CardContainer title="WORK ANNIVERSARY" variant={"bg-success"}>
                {dashboard?.workAnniversaryList?.map((item, idx) => {
                  return (
                    <ProfileCard
                      name={item.staffName}
                      role={item.jobTitle}
                      image={
                        item.profileImage
                          ? item.profileImage
                          : "https://www.pngitem.com/pimgs/m/581-5813504_avatar-dummy-png-transparent-png.png"
                      }
                      action={() => handleWhishes("work", item)}
                      employeeId={item.employeeId}
                      date={item.workAnniversaryDate}
                    />
                  );
                })}
              </CardContainer>
            </Col>
          ) : null}
          {dashboard?.birthdayList?.length > 0 ? (
            <Col sm="4" className="mb-3">
              <CardContainer
                title="BIRTHDAY CELEBRATION"
                variant={"bg-warning"}
              >
                {dashboard?.birthdayList?.map((item, idx) => {
                  return (
                    <ProfileCard
                      name={item.staffName}
                      role={item.jobTitle}
                      image={
                        item.profileImage
                          ? item.profileImage
                          : "https://www.pngitem.com/pimgs/m/581-5813504_avatar-dummy-png-transparent-png.png"
                      }
                      action={() => handleWhishes("birthday", item)}
                      employeeId={item.employeeId}
                      date={item.birthdayDate}
                    />
                  );
                })}
              </CardContainer>
            </Col>
          ) : null}
          {/* Quick lick */}
          {/* <Col sm="4">
            <Card className="mt-2 overview-container">
              <Card.Header className="c-hed">Quick Link</Card.Header>
              <Card.Body>
                <ul className="overview-list">
                  <li>
                    <Link to="/attendance-setting">
                      Manage Auto Clock-Out Settings <ArrowForwardIcon />
                    </Link>
                  </li>
                  <li>
                    <Link to="/notification">
                      View Requests <ArrowForwardIcon />
                    </Link>
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col> */}

          {/* <Col sm="4" className="mb-3">
            <CardContainer title="EMPLOYEE APPRECIATION" variant={"bg-primary"}>
              <ProfileCard
                name="Albert Flores"
                role="UI/UX Designer"
                image="https://randomuser.me/api/portraits/men/32.jpg"
                action={() => handleWhishes("employment", item)}
              />
            </CardContainer>
          </Col> */}
        </Row>
      </div>
      {/* TABLE */}
      <div style={{ padding: "0 45px" }} className="mt-3">
        <Widgets
          icon={<WidgetsIcon icon={<CiUser />} title="Leave Request" />}
          button={
            <div style={{ width: "100%" }}>
              <WidgetsButton
                type="text"
                name="searchQuery"
                value={searchQuery}
                variant="dark"
                text="Search"
                placeholder="Search by Employee name/employee Id"
                width="300px"
                onClick={searchDetails}
                className="universal-input-one p-2"
              />
            </div>
          }
          body={
            <>
              <div
                className="ag-theme-quartz custom-grid mt-3"
                style={{ height: "calc(100vh - 280px)", width: "100%" }}
              >
                <AgGridReact
                  rowData={Array.isArray(description) ? description : []}
                  columnDefs={columns}
                  omLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  paginationPageSizeSelector={paginationPageSizeSelector}
                  onGridReady={onGridReady}
                />
              </div>
              <div className="d-flex align-items-center justify-content-between custom-pagination">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />
      </div>

      {/* <Modal fullscreen={false} show={show} onHide={handleClose} size={"md"}>
        <Modal.Header closeButton>
          <Modal.Title>Add Reason To {leaveActionType} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Control
              name="reason"
              value={approveStatus.reason}
              onChange={handleReason}
              placeholder="Enter reason"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="universal-input-one"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="universal-btn"
            onClick={saveApprovalStatus}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal> */}

      <Dialog
        open={show}
        keepMounted
        onClose={handleClose}
        maxWidth="sm" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        // className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">{leaveActionType}</span>
          </div>

          <button className="universal-btn" onClick={saveApprovalStatus}>
            {leaveActionType == "Reject Request" ? "Reject" : "Approve"}
          </button>
        </DialogTitle>
        <DialogContent className="pure-dark-bg-colors">
          {leaveActionType == "Approve Request" && (
            <div>
              <div className="d-flex align-items-center justify-content-between mt-3">
                <div className="user-profile">
                  <span className="table-links d-flex align-items-center justify-content-start gap-2">
                    <div
                      style={{
                        width: "70px",
                        height: "70px",
                        border: "1px solid lightgray",
                        borderRadius: "50%",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: getInitialColor(
                          selectedLeave.staffName
                        ),
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "12px",
                      }}
                    >
                      {getInitials(selectedLeave.staffName)}
                    </div>
                    <span>
                      <h3 className="color-white">{getCapitalizeWord(selectedLeave.staffName)}</h3>
                      <span className="color-gray" style={{ fontSize: "14px" }}>
                        {selectedLeave.empId}
                      </span>
                    </span>
                  </span>
                </div>
                <div className="leave-sections d-flex align-items-center justify-content-between gap-2">
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ fontSize: "14px" }} className="color-white">Paid Leave</span>
                    <CircularProgress
                      v1={1}
                      v2={2}
                      textSize="20"
                      textColor={theme == "light" ? "#000" : "#fff" }
                      pathColor="#FFCB3E"
                      trailColor="gray"
                      strokeWidth="15"
                      width="70px"
                      height="70px"
                    />
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ fontSize: "14px" }} className="color-white">Casual Leave</span>
                    <CircularProgress
                      v1={1}
                      v2={2}
                      textSize="20"
                      textColor={theme == "light" ? "#000" : "#fff" }
                      pathColor="#FF6557"
                      trailColor="gray"
                      strokeWidth="15"
                      width="70px"
                      height="70px"
                    />
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ fontSize: "14px" }} className="color-white">Sick Leave</span>
                    <CircularProgress
                      v1={1}
                      v2={2}
                      textSize="20"
                      textColor={theme == "light" ? "#000" : "#fff" }
                      pathColor="#8660F8"
                      trailColor="gray"
                      strokeWidth="15"
                      width="70px"
                      height="70px"
                    />
                  </div>
                </div>
              </div>
              <hr  className="color-gray"/>

              <div>
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="color-gray">From Date</span>
                  <span className="color-white">{selectedLeave.start_date}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="color-gray">From Date</span>
                  <span className="color-white">{selectedLeave.end_date}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="color-gray">Total Days</span>
                  <span className="color-white">{selectedLeave.duration}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="color-gray">Reason</span>
                  <span className="color-white">{selectedLeave.reason}</span>
                </div>
              </div>
            </div>
          )}

          {leaveActionType == "Reject Request" && (
            <Form.Group className="mt-3">
              <Form.Control
                name="reason"
                value={approveStatus.reason}
                onChange={handleReason}
                placeholder="Enter reason"
                className="universal-input-one"
              />
            </Form.Group>
          )}
        </DialogContent>
      </Dialog>

      {/* ----------------------------------- */}
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={show1}
        onClose={handleClose1}
        // className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => handleClose1(false)}>
              X
            </span>
            <span className="title">
              {whishType == "birthday"
                ? "Birthday Wish"
                : whishType == "work"
                ? "Work Anniversary Wish"
                : "Employment Wish"}
            </span>
          </div>
          <button className="universal-btn" onClick={submitWhishes}>
            Wish
          </button>
        </DialogTitle>
        <DialogContent>
          <>
            <div className="d-flex align-items-center justify-content-start gap-3 mt-3 wish-header">
              <img
                src={
                  userData.profileImage
                    ? userData.profileImage
                    : "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlciUyMHByb2ZpbGV8ZW58MHx8MHx8fDA%3D"
                }
                alt="profile"
                className="rounded-img-60"
              />
              <div className="d-flex flex-column justify-content-start align-items-start gap-1">
                <span className="title color-white">{userData.staffName}</span>
                <span className="sub-title color-gray">
                  {userData.employeeId}
                </span>
              </div>
            </div>

            <div className="mt-3">
              <Form.Group>
                <Form.Label className="color-gray">
                  Wish your Employee
                </Form.Label>
                <Form.Control
                  name="wishes"
                  as="textarea"
                  value={wishState.wishes}
                  onChange={handleWishInputChange}
                  placeholder="Type your wish here..."
                  className="universal-input-one color-gray"
                  style={{ height: "150px" }}
                />
              </Form.Group>
            </div>
          </>
        </DialogContent>
      </Dialog>
      {/* ----------------------------------- */}

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  ) : (
    <span>You Don't Have Any Access!</span>
  );
};

export default Dashboard;
